import {
  CollectionCompatibilityMode,
  CollectionLifecycle,
  CollectionRole,
  hasCollectionCapability,
} from '@qkindex/contracts';

export const collectionCapabilities = (
  compatibilityMode: CollectionCompatibilityMode,
  role?: CollectionRole,
  lifecycle: CollectionLifecycle = 'active',
) => {
  const available = compatibilityMode === 'collection-only';
  const granted = (capability: Parameters<typeof hasCollectionCapability>[1]) =>
    available &&
    lifecycle === 'active' &&
    Boolean(role && hasCollectionCapability(role, capability));
  const active = lifecycle === 'active';
  return {
    canEditInventory: active && granted('editInventory'),
    canManageCollection: granted('manageOwnership'),
    canManageMembers: active && granted('manageMembers'),
    canManageAdministrators: active && granted('manageAdministrators'),
    canAdministerInventory: active && granted('administerInventory'),
    canRenameCollection: active && granted('renameCollection'),
    canMoveItemsOut: active && granted('moveItemsOut'),
    canViewActivity: granted('viewActivity'),
    canManageBilling: granted('manageBilling'),
    canManageAiPolicy: active && granted('manageAiPolicy'),
    canManageOwnership: granted('manageOwnership'),
  };
};

export type CollectionCapabilities = ReturnType<typeof collectionCapabilities>;
